import { downloadCollectionYardVisitReceiptThunk } from "../../reducers/collectionYardsReducer";
import { useAppDispatch } from "../../store";
import { Icon, IconNameEnum } from "../Icon";

interface DownloadCollectionYardVisitReceiptProps {
  visitId: number;
}

export const DownloadCollectionYardVisitReceipt: React.FC<DownloadCollectionYardVisitReceiptProps> = ({ visitId }) => {
  const dispatch = useAppDispatch();

  const handleDownload = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    dispatch(downloadCollectionYardVisitReceiptThunk(visitId));
  };

  return <Icon name={IconNameEnum.download} onClick={handleDownload} />;
};
